import Api from '../../services/api';
import { getProp } from '../../utilities';

import {
  FETCH_BUSS_SUCCESS,
  FETCH_BUSS_ERROR,
  FETCH_BUSS,
  CLEAR_BUSSES,
} from './constants';

export const fetchBuss = () => ({
  type: FETCH_BUSS,
});

export const fetchBussSuccess = (data, idBuss) => ({
  type: FETCH_BUSS_SUCCESS,
  payload: data,
  idBuss,
});

export const fetchBussFailure = (error, idBuss) => ({
  type: FETCH_BUSS_ERROR,
  payload: error,
  idBuss,
});

export const clearBusses = () => ({
  type: CLEAR_BUSSES,
});

export const fetchBus = (from, to, idBuss) => {
  return dispatch => {
    dispatch(fetchBuss());
    Api.getBus(from, to, idBuss)
      .then(res => {
        if (getProp(res, ['errors'], []).length === 0) {
          dispatch(fetchBussSuccess(res, idBuss));
        } else {
          dispatch(fetchBussFailure(res.errors[0], idBuss));
        }
      })
      .catch(error => {
        dispatch(fetchBussFailure(error, idBuss));
      });
  };
};



// WEBPACK FOOTER //
// ./src/components/Bus/actions.js